// 2026-10-07 · «Fichar» no cambia el empleado de la tablet.
//
// Con un empleado identificado en la tablet, «Fichar» abre SU modal de fichaje
// (sin PIN: ya está identificado). Sin empleado (admin o kiosko), se abre el
// kiosko en modo «fichar»: se elige quién ficha + PIN y la tablet sigue como
// estaba. Solo «Cambiar empleado» identifica a alguien en el dispositivo.

/** Qué hace el botón «Fichar» de la barra superior. */
export function planFichar({ needsKiosk, currentActiveEmployee }) {
  if (needsKiosk) return { type: "kiosk" };
  return { type: "modal", employeeId: currentActiveEmployee || null };
}

/**
 * Qué hace el kiosko en modo «fichar» al elegir a un empleado.
 *  - admin → no ficha: vuelve a la selección normal.
 *  - verifyPin → comprobar el PIN sin identificar (solo si tiene PIN y se tecleó).
 *  - returnToKiosk → si el kiosko estaba forzado (nadie en la tablet), al
 *    cerrar el modal de fichaje se vuelve a él.
 */
export function planKioskClocking({ emp, pin, kioskManual }) {
  if (!emp || emp.isAdmin) return { type: "admin" };
  return {
    type: "clock",
    employeeId: emp.id,
    verifyPin: !!(emp.password && pin),
    returnToKiosk: !kioskManual,
  };
}

// Fichajes olvidados: shifts abiertos de días anteriores (los de hoy son el
// empleado trabajando ahora, no un olvido). `pendingOpenShifts` lo calcula el
// backend (WorkScheduleItems de los últimos 4 días con un shift abierto).
export function countForgottenShifts(emp, today = new Date()) {
  if (!emp || emp.isAdmin) return 0;
  const isToday = (iso) => {
    if (!iso) return false;
    const d = new Date(iso.endsWith?.("Z") ? iso : `${iso}Z`);
    return (
      d.getFullYear() === today.getFullYear() &&
      d.getMonth() === today.getMonth() &&
      d.getDate() === today.getDate()
    );
  };
  let count = 0;
  const pending = Array.isArray(emp.pendingOpenShifts) ? emp.pendingOpenShifts : [];
  for (const item of pending) {
    if (isToday(item.start)) continue;
    for (const s of item.shifts || []) {
      if (s.checkInTime && !s.checkOutTime) count++;
    }
  }
  return count;
}
